import { customerTicketing } from './customer-ticketing';

export const frCA = { customerTicketing };
